import React from 'react';
import Skeleton from '../../../ui/skeleton/Skeleton';

export default function ConfigurationRulesSkeleton() {
  return (
    <div className="space-y-3 mb-1 p-2">
      <div className="flex flex-initial justify-items-center">
        <Skeleton className="w-3/12 mr-20"/>
        <Skeleton className="w-1/3 h-12"/>
      </div>
      <div className="flex flex-initial">
        <Skeleton className="w-3/12 mr-20"/>
        <Skeleton className="w-1/3 h-12"/>
      </div>
    </div>
  );
}
